"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_notification_ui_1 = require("@synisys/idm-notification-ui");
var header_bar_component_1 = require("./header-bar.component");
var pin_unpin_service_1 = require("../navigation/api/pin-unpin.service");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var pin_unpin_service_impl_1 = require("../../services/pin-unpin.service.impl");
var login_guard_service_1 = require("../../services/login-guard.service");
var shared_module_1 = require("../shared.module");
var router_1 = require("@angular/router");
var about_component_1 = require("./about/about.component");
exports.uiOptions = window['uiOptions']
    ? window['uiOptions']
    : document['uiOptions']
        ? document['uiOptions']
        : undefined; // workaround for aot
/**
 * This variable is globally initialized during bootstrap
 */
// Below options are passed from backend because they are needed early before module load
// to determine if some components need to be created or not
exports.showAboutSection = exports.uiOptions !== undefined && exports.uiOptions.hasAbout;
exports.showContactSection = exports.uiOptions !== undefined && exports.uiOptions.hasContact;
/**
 * Created by Hayk.Andriasyan on 10/16/2017.
 */
var ShellHeadersBarModule = /** @class */ (function () {
    function ShellHeadersBarModule() {
    }
    ShellHeadersBarModule = __decorate([
        core_1.NgModule({
            imports: [idm_notification_ui_1.NotificationModule, shared_module_1.SharedModule, router_1.RouterModule],
            declarations: exports.showAboutSection ? [header_bar_component_1.HeaderBarComponent, about_component_1.AboutComponent] : [header_bar_component_1.HeaderBarComponent],
            exports: [header_bar_component_1.HeaderBarComponent],
            entryComponents: exports.showAboutSection ? [about_component_1.AboutComponent] : [],
            providers: [login_guard_service_1.LoginGuard, idm_authorization_client_js_1.PermissionGuard, { provide: pin_unpin_service_1.PinUnpinService, useClass: pin_unpin_service_impl_1.PinUnpinServiceImpl }]
        })
    ], ShellHeadersBarModule);
    return ShellHeadersBarModule;
}());
exports.ShellHeadersBarModule = ShellHeadersBarModule;
//# sourceMappingURL=shell.header.bar.module.js.map